export function customHide(showlog = false) {
  if (showlog) {
    return '';
  } else {
    return 'customHide';
  }
}